export default {
  pageTitle: 'Layanan Patching',
  metaDescription: 'TEF menyediakan layanan patching on-site untuk kebocoran shell dan piping, memberikan perbaikan cepat dan hemat biaya tanpa perlu bongkar atau transportasi.',
  sidebar: {
    heading: 'Daftar Pemeliharaan dan Rekondisi',
    weldingOverlay: 'Welding Overlay',
    patching: 'Patching',
    piping: 'Piping',
    reshell: 'Re-Shell',
    retubing: 'Re-Tubing',
  },
  title: 'Patching',
  heading: 'Layanan Patching di Lokasi untuk Kebocoran Shell dan Piping',
  paragraph1: 'Kami menyediakan solusi patching yang efisien dan andal untuk mengatasi kebocoran pada shell dan piping, dikerjakan langsung di lokasi Anda. Peralatan portabel dan teknisi berpengalaman kami memastikan perbaikan yang cepat dan efektif, sehingga meminimalkan downtime dan mencegah kerusakan lebih lanjut pada sistem Anda.',
  paragraph2: 'Pendekatan di lokasi ini menghilangkan kebutuhan untuk membongkar atau memindahkan peralatan, sehingga menjadi solusi yang hemat biaya dan praktis. Baik untuk perbaikan sementara maupun jangka panjang, kami menjamin kualitas pengerjaan terbaik yang disesuaikan dengan kebutuhan operasional Anda.',
  steps: {
    step1: 'Melepas Insulasi Bagian Luar',
    step2: 'Patching Shell Bagian Luar',
    step3: 'Perbaikan Shell Bagian Dalam',
    step4: 'Patching Shell Bagian Luar',
    step5: 'Patching Shell Bagian Dalam',
    step6: 'Patching Nozzle Bagian Luar',
    step7: 'Shell Bagian Dalam',
  },
};
